import { Escalation, PhaseDateTime } from './../../models/phases';
import { Phases } from '../../models/phases';
import { PhaseService } from './../../services/phase.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbToastrService, NbComponentStatus, NbDialogRef } from '@nebular/theme';
import { FormMAsterService } from '../../../../../DynamicFormsModule/formsMaster/services/formMaster.service';
import { SelectItems } from '../../../../../shared/Models/SelectItems';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
})
export class CreatePhaseComponent implements OnInit {
  requiredCreateDate: SelectItems[] = [];
  phase: Phases = {} as Phases;
  users: any[];
  legals: any[];
  userSectionFlg: boolean;
  legalSectionFlg: boolean;
  userEscalationSectionFlg: boolean;
  escalDays: number;
  escaleHours: number;
  dynmicFormList: any[] = [];
  finishLoading: boolean;
  workflowId: number;
  escalationList = [{} as Escalation];
  constructor(
    private service: PhaseService,
    private route: ActivatedRoute,
    private toastrService: NbToastrService,
    private router: Router,
    private dFormService: FormMAsterService,
    private ref: NbDialogRef<CreatePhaseComponent>
  ) {}
  timeType = [
    { name: 'شهر', id: 1 },
    { name: 'يوم', id: 2 },
    { name: 'ساعه', id: 3 },
  ];
  assignUserTypes = [
    { name: 'بالصفة الشخصية', id: 1 },
    { name: 'بالوظيفة', id: 2 },
    // { name: 'User Group', id: 3 },
    // { name: 'Unit', id: 4 },
    { name: 'مقدم الطلب', id: 5 },
  ];
  escalationMethods = [
    { name: 'One Level Up', id: 1 },
    { name: 'Multi Level Up', id: 2 },
    { name: 'مستخدم', id: 3 },
  ];
  ngOnInit() {
      this.router.events.subscribe(()=>{
      this.ref.close('false');
     });
    this.loadRequiredCreateDate();
    this.phase.workFlowId = this.workflowId;
    this.phase.escalationVm = {} as Escalation;
    this.phase.escalationVms = [{} as Escalation];

    this.phase.optimal = {} as PhaseDateTime;
    this.phase.normal = {} as PhaseDateTime;
    this.dFormService.getCreateNew().subscribe((res) => {
      this.dynmicFormList = res[0].values;
      this.finishLoading = true;
    });
  }
DisapledfirstStepButton() : boolean
{
  if(!this.phase.name || !this.phase.sequence)
  {
  return true;
  }
  return false;
}
DisapledSecondStepButton() : boolean
{
  if(!this.phase.normal.timeValue 
    ||!this.phase.optimal.timeValue
  )
  {
  return true;
  }
  return false;
}
DisapledFinalStepButton() : boolean
{
  if(this.phase.escalationVms === null || 
    this.phase.escalationVms.length === 0 || 
    this.phase.escalationVms.some(e => !e.flgPeriodRef ))
  {
  return true;
  }
  return false;
}
  addinput() {
    this.phase.escalationVms.push({} as Escalation);
  }
  loadRequiredCreateDate() {
    this.service.getCreate().subscribe((res) => {
      this.requiredCreateDate = res;
    });
  }

  addNewPhase() {
    // this.service.post(this.phase).subscribe(res => {});
  }
  dropdownChange($event) {
    switch ($event) {
      case 1:
        this.initalize();
        this.userSectionFlg = true;
        this.service.getPhaseUsers(1).subscribe((res) => {
          this.users = [];
          this.users = res;
          this.users.push({ id: 0, name: 'جميع المستخدمين' });
        });
        // this.users = [{ name: 'ali', id: 2 }];
        break;
      case 2:
        this.initalize();
        this.legalSectionFlg = true;
        this.service.getPhaseUsers(2).subscribe((res) => {
          this.legals = res;
        });
        break;
      case 4:
        this.initalize();
        this.legalSectionFlg = true;
        this.service.getPhaseUsers(4).subscribe((res) => {
          this.legals = res;
        });
        break;
      default:
        this.initalize();
    }
  }
  escalationChange($event) {
    switch ($event) {
      case 3:
        if (this.users == null || this.users.length === 0) {
          this.service.getPhaseUsers(1).subscribe((res) => {
            this.users = res;
          });
        }
        this.userEscalationSectionFlg = true;
        break;
      default:
        this.userEscalationSectionFlg = false;
    }
  }
numbersOnly(event: any ) {
  const input = event.target as HTMLInputElement;
  input.value = input.value.replace(/[^0-9]/g, '');
}

  initalize() {
    this.userSectionFlg = false;
    this.legalSectionFlg = false;
  }
  save() {
    // console.log(this.phase);
    // this.phase.FlgAssignRef = 1;
    // this.phase.FlgAssignType = 1;
    // this.phase.escalationVm.flgEscaleToType = 1;
    // this.phase.escalationVm.escaleToRef = '1';
    // this.phase.escalationVm.flgPeriodRef = 3;
    // this.phase.escalationVm.flgPeriodType = 3;
    this.service.post(this.phase).subscribe((res) => {
      const position = 'top-right';
      this.showToast(position, `add phase ${this.phase.name} successfully`, 'success');
      this.ref.close('true');
      // this.phase = {} as Phases;
      // this.router.navigate(['admin/workflow']);
      //   this.ngOnInit();
      //  this.phase = {} as Phases;
      // console.log(res);
      // console.log(this.phase);
    });
  }
  showToast(position, message, status: NbComponentStatus) {
    this.toastrService.show(message, '', { position, status });
  }
  back() {
    const route = ['workflow'];
    this.router.navigate(route);
  }

  close() {
    this.ref.close();
  }
}
